import { render } from "./recordList.vue?vue&type=template&id=818fe14e&scoped=true"
import script from "./recordList.vue?vue&type=script&lang=js"
export * from "./recordList.vue?vue&type=script&lang=js"

import "./recordList.vue?vue&type=style&index=0&id=818fe14e&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-818fe14e"],['__file',"src/views/alfmeier/advertise/recordList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "818fe14e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('818fe14e', __exports__)) {
    console.log('reload')
    api.reload('818fe14e', __exports__)
  }
  
  module.hot.accept("./recordList.vue?vue&type=template&id=818fe14e&scoped=true", () => {
    console.log('re-render')
    api.rerender('818fe14e', render)
  })

}


export default __exports__